import { render } from "./VPagination.vue?vue&type=template&id=7c535b20&scoped=true&ts=true"
import script from "./VPagination.vue?vue&type=script&lang=ts"
export * from "./VPagination.vue?vue&type=script&lang=ts"

import "./VPagination.vue?vue&type=style&index=0&id=7c535b20&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c535b20"]])

export default __exports__